/** @jsx jsx */
import { jsx } from '@emotion/core'
import ScatterMenu from './ScatterMenu'
import Scatter from './Scatter'
import { caGraphSpecs, createServiceHourSpecs } from './scatter-graph-spec'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { getKpiSpec } from '../selectors'
import { Content, FullHeightSizer } from 'core/screen-util'

const specToRoute = spec => {
  const { group, id } = spec
  return (
    <Route
      key={`${group.id}-${id}-content`}
      path={`/scatter/${group}/${id}`}
      render={_ => <Scatter group={group} id={id} spec={spec} />}
    />
  )
}

const ScatterContainer = ({ kpiSpec }) => (
  <FullHeightSizer heightOffset={170}>
    {({ height }) => (
      <Content css={{ height: height - 20, paddingTop: '10px', minHeigh: height }}>
        <ScatterMenu
          style={{
            position: 'absolute',
            right: '15px',
            maxHeight: height - 40,
            overflowY: 'auto',
          }}
        />
        {caGraphSpecs.map(specToRoute)}
        {createServiceHourSpecs(kpiSpec).map(specToRoute)}
      </Content>
    )}
  </FullHeightSizer>
)

const mapStateToProps = state => ({
  kpiSpec: getKpiSpec(state),
})
export default connect(mapStateToProps)(ScatterContainer)
